// Offert-status konfiguration (matchar estimat-standarden)
export const getOffertStatusConfig = (status) => {
  switch (status) {
    case 'Utkast offert':
      return {
        status: 'Utkast offert',
        color: 'bg-gray-400 text-white', // Matchar estimat draft
        priority: 1
      };
    case 'Skickat offert':
      return {
        status: 'Skickat offert',
        color: 'bg-blue-400 text-white', // Matchar estimat sent
        priority: 2
      };
    case 'Sett offert':
      return {
        status: 'Sett offert',
        color: 'bg-yellow-500 text-white', // Ny status som matchar estimat-färgschema
        priority: 3
      };
    case 'Feedback mottaget':
      return {
        status: 'Feedback mottaget',
        color: 'bg-blue-500 text-white', // Matchar estimat feedback_received
        priority: 4
      };
    case 'Feedback skickat':
      return {
        status: 'Feedback skickat',
        color: 'bg-purple-500 text-white', // Matchar estimat feedback_answered
        priority: 5
      };
    case 'Godkänt offert':
      return {
        status: 'Godkänt offert',
        color: 'bg-green-500 text-white', // Matchar estimat approved
        priority: 6
      };
    case 'Avböjt offert':
      return {
        status: 'Avböjt offert',
        color: 'bg-red-500 text-white', // Matchar estimat declined
        priority: 7
      };
    case 'Utgånget offert':
      return {
        status: 'Utgånget offert',
        color: 'bg-gray-400 text-white', // Matchar estimat draft färg
        priority: 8
      };
    default:
      return {
        status: status || 'Okänd status',
        color: 'bg-gray-400 text-white',
        priority: 0
      };
  }
};

// Funktion för att hämta intelligent offert-status från backend
export const fetchOffertStatus = async (offertId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/offert/${offertId}/status`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw new Error('Kunde inte hämta offert-status');
    }

    const data = await response.json();
    return data.success ? data.data : null;
  } catch (error) {
    console.error('❌ Fel vid hämtning av offert-status:', error);
    return null;
  }
};
